import { render, staticRenderFns } from "./LoginPTSI.vue?vue&type=template&id=50fa5105&scoped=true"
import script from "./LoginPTSI.vue?vue&type=script&lang=js"
export * from "./LoginPTSI.vue?vue&type=script&lang=js"
import style0 from "./LoginPTSI.vue?vue&type=style&index=0&id=50fa5105&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fa5105",
  null
  
)

export default component.exports